@if (contactFields) {
  <div>
    @if (contactInfo.length === 0) {
      <div class="add-contact-report" (click)="editContacts()">
        <a><mat-icon svgIcon="add-fill"></mat-icon>{{ 'searchContact.addContact' | translate }}</a>
      </div>
    }
    @if (contactInfo.length > 0) {
      <div class="add-contact-banner">
        @for (contact of contactInfo; track contact; let i = $index) {
          <div class="contact-card">
            <div class="circle-container" [ngStyle]="{ 'background-color': i | getColor }">
              <span> {{ contact.name | getContactInitials }}</span>
            </div>
            <div class="content-wrapper">
              @if (contact.name) {
                <div class="contact-title">{{ contact.name }}</div>
              }
              @if (contact.role) {
                <div class="email">{{ contact.role }}</div>
              }
              @if (contact.phone) {
                <div class="email">{{ contact.phone }}</div>
              }
              @if (contact.email) {
                <div class="email">{{ contact.email }}</div>
              }
            </div>
            <div>
              <div class="contact-bgcolor">
                <div class="contactCheck">
                  <mat-icon
                    class="contact-close"
                    color="y-icon"
                    svgIcon="edit"
                    (click)="contactOverlay.toggle($event); editNamePhoneContact(contact)"
                  ></mat-icon>
                  <mat-icon
                    class="contact-close"
                    color="y-icon"
                    svgIcon="close"
                    (click)="removeContact(contact.id)"
                  ></mat-icon>
                </div>
              </div>
            </div>
            <p-popover #contactOverlay [dismissable]="true" appendTo="body" styleClass="contact-settings-overlay">
              <rep-contact-settings
                [reportId]="reportId()"
                [selectedContact]="selectedContact"
                [phoneCatalog]="phoneCatalog"
                (refreshContacts)="getContacts()"
              ></rep-contact-settings>
            </p-popover>
          </div>
        }
        <div class="edit-icon" (click)="editContacts()">
          <a><mat-icon class="contact-close" svgIcon="edit"></mat-icon>{{ 'searchContact.edit' | translate }}</a>
        </div>
      </div>
    }
  </div>
}
